import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import { getCurrentInstance, reactive, ref,onMounted } from 'vue'
import { useRoute, useRouter} from 'vue-router'
import PaginationVue from '@/components/Pagination.vue'
import SelectBrand from '@/components/SelectBrand.vue'
import SelectCity from '@/components/SelectCity.vue'
import RejectDialog from '@/components/RejectDialog.vue'
import { getDeliveryListApi, rejectDeliveryApi, passDeliveryApi } from '@/apis/delivery'
import Pagination from '@/components/Pagination.vue'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'



export default /*@__PURE__*/_defineComponent({
  __name: 'ReconciliationList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()

const filters = reactive({
    brand_id:   '',     // 品牌ID
    status:'',
    remittance_status:'',
    invoice_type:'',
    recive_start_date:'',   //收票开始日期
    recive_end_date:'',     //收票结束日期
    bet_start_date:'',      //对账开始日期
    bet_end_date:'',        //对账结束日期
    pay_start_date:'',      //付款开始日期
    pay_end_date:'',        //付款结束日期
    page:       1,
    page_size:  10,
})
const state = reactive({
    dateList:       [],
    
    })
// 获取运费审核列表
const tableData = ref([])
const total = ref(0)
const getList = async () => {
    const { code, data, count, msg } = await getDeliveryListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total
}
//导出
const onExport = (type) => {
    window.open(`${Keys.baseUrl}/admin/merchant/get_ordergmv_list?${joinParams({...filters, user_id: store.state.user.userInfo.id})}&export=${type}`)
}
// 多选监听
const multipleTable = ref()
const selectedIds = ref<string[]>([])

// 驳回功能
const dialogShow = ref<boolean>(false)
const rowId = ref<string>('')
const rejection_msg = ref<string>('')
const onReject = async () => {
    if (!rejection_msg.value) return proxy.$message({ type: 'error', message: '请输入驳回原因' })
    let formData = {
        id: rowId.value,
        rejection_msg: rejection_msg.value
    }
    const {code, data, msg} = await rejectDeliveryApi(formData) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    proxy.$message({ type: 'success', message: '审核成功' })
    dialogShow.value = false
    getList()
}

// 查看配规详情
const toDetail = (row) => {
    // const { type, city_id, brand_id, rule_id, city_name } = row
    router.push(`/merchant-admin/reconciliation-detail`)
}

const onBrandChange = (val) => {
    filters.brand_id = val
}

const search = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}
onMounted(() => {
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectBrand, { onBrandChange: onBrandChange }),
      _createVNode(_component_el_select, {
        class: "filter-item",
        style: {"width":"150px"},
        modelValue: filters.date,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.date) = $event)),
        placeholder: "时间（月份）"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.dateList, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.value,
              value: item.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.status) = $event)),
        placeholder: "账单状态",
        style: {"width":"150px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: "2"
          }),
          _createVNode(_component_el_option, {
            label: "未对账",
            value: "0"
          }),
          _createVNode(_component_el_option, {
            label: "对账完成",
            value: "1"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.remittance_status,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.remittance_status) = $event)),
        placeholder: "发票状态",
        style: {"width":"150px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: "2"
          }),
          _createVNode(_component_el_option, {
            label: "未回款",
            value: "0"
          }),
          _createVNode(_component_el_option, {
            label: "汇款完成",
            value: "1"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.invoice_type,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.invoice_type) = $event)),
        placeholder: "结算状态",
        style: {"width":"150px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: "2"
          }),
          _createVNode(_component_el_option, {
            label: "未添加",
            value: "0"
          }),
          _createVNode(_component_el_option, {
            label: "已添加",
            value: "1"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.recive_start_date,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.recive_start_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "收票开始日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.recive_end_date,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.recive_end_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "收票结束日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.bet_start_date,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.bet_start_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "对账开始日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.bet_end_date,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.bet_end_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "对账结束日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.pay_start_date,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.pay_start_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "付款开始日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.pay_end_date,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.pay_end_date) = $event)),
        "value-format": "YYYY-MM-DD",
        placeholder: "付款结束日期",
        style: {"width":"150px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: search
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "city_name",
          label: "品牌折扣"
        }),
        _createVNode(_component_el_table_column, {
          prop: "region_name",
          label: "账单月份"
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoice_type",
          label: "订单总金额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoice_title",
          label: "实际结算总金额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoice_content",
          label: "账单状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "shenhe_amount",
          label: "对账时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "shenhe_amount",
          label: "发票状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "shenhe_amount",
          label: "收票时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "shenhe_amount",
          label: "结算状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "付款时间",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_tag, {
                size: "small",
                onClick: ($event: any) => (toDetail(scope.row))
              }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_tag, {
                size: "small",
                onClick: onExport
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode("导出")
                ])),
                _: 1
              }),
              _createVNode(_component_el_tag, {
                size: "small",
                onClick: ($event: any) => {dialogShow.value=true;rowId.value=scope.row.id;rejection_msg.value=''}
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode("对账")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "手工调整",
      modelValue: dialogShow.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dialogShow).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[11] || (_cache[11] = ($event: any) => (dialogShow.value=false))
        }, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onReject
        }, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "备注",
              required: "",
              style: {"width":"450px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  rows: 5,
                  maxlength: "150",
                  "show-word-limit": "",
                  modelValue: rejection_msg.value,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((rejection_msg).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})